import { useDispatch } from "react-redux";
import { setSoundType } from "store/sounds";
import useProfile from "./useProfile";

export const useSoundPath = () => {
  const dispatch = useDispatch();
  const {flags} = useProfile();

  const setSound = (type) => {
    if (flags.sound === true) {
      dispatch(setSoundType(type));
      setTimeout(() => dispatch(setSoundType(''), 0))
    }
  };

return setSound;
}
